// extracted by mini-css-extract-plugin
var _1 = "Avatar-moduleavatar__cNFgJ";
var _2 = "Avatar-modulebackground__Ow_Uo";
var _3 = "Avatar-moduleimage__XgYn2";
var _4 = "Avatar-modulesize100__KJnjv";
var _5 = "Avatar-modulesize16__rhEFh";
var _6 = "Avatar-modulesize20__EWQCh";
var _7 = "Avatar-modulesize24__u2mP5";
var _8 = "Avatar-modulesize32__qn6cm";
var _9 = "Avatar-modulesize40__ZxQh6";
var _a = "Avatar-modulesize48__jka49";
var _b = "Avatar-moduleskeleton__PhSzQ Skeleton-moduleSkeleton__Mlrfv";
var _c = "Avatar-moduletext__JenMw";
export { _1 as "avatar", _2 as "background", _3 as "image", _4 as "size100", _5 as "size16", _6 as "size20", _7 as "size24", _8 as "size32", _9 as "size40", _a as "size48", _b as "skeleton", _c as "text" }
